import { Grid2, styled } from '@mui/material'
import Typography from '@mui/material/Typography'

export const RowContainer = styled('div')(({ theme }) => ({
  padding: '5px',
  borderBottom: `1px solid ${theme.palette.divider}`,
}))

export const DataCell = styled(Grid2)(() => ({
  paddingTop: '8px',
}))

export const Truncate = styled(Typography)(() => ({
  whiteSpace: 'nowrap',
  overflow: 'hidden',
  textOverflow: 'ellipsis',
}))

export const RowLoader = styled(Grid2)(() => ({
  textAlign: 'center',
}))
